export class MenuDb {
  public static menu: any = [
    {
      title: 'Я и сферы бизнеса',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      page: '/industry',
      translate: 'MENU.INDUSTRY',
      bullet: 'dot',
    },
    {
      title: 'Бюджет-помощник',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      page: '/budget',
      translate: 'MENU.BUDGET',
      bullet: 'dot',
    },
    {
      title: 'Тревел-политика',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      page: '/travel',
      translate: 'MENU.TRAVEL',
      bullet: 'dot',
    },
    {
      title: 'Рекомендации',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      page: '/recomendations',
      translate: 'MENU.RECOMENDATIONS',
      bullet: 'dot',
    },
    {
      title: 'Настройки',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      page: '/settings',
      translate: 'MENU.SETTINGS',
      bullet: 'dot',
    },
    {
      title: 'Выйти',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      page: '/auth/logout',
      translate: 'MENU.LOGOUT',
      bullet: 'dot',
    },
  ];
}
